import * as tslib_1 from "tslib";
import { IgrCellInfo } from "./igr-cell-info";
import { NumericCellModel as NumericCellModel_internal } from "./NumericCellModel";
import { ensureBool } from "igniteui-react-core";
/**
 * Backing information for a numeric cell in the grid.
*/
var IgrNumericCellInfo = /** @class */ /*@__PURE__*/ (function (_super) {
    tslib_1.__extends(IgrNumericCellInfo, _super);
    function IgrNumericCellInfo() {
        return _super.call(this) || this;
    }
    IgrNumericCellInfo.prototype.createImplementation = function () {
        return new NumericCellModel_internal();
    };
    Object.defineProperty(IgrNumericCellInfo.prototype, "i", {
        /**
                                     * @hidden
                                     */
        get: function () {
            return this._implementation;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(IgrNumericCellInfo.prototype, "numericValue", {
        /**
         * Sets or gets the numeric value to use for the cell.
        */
        get: function () {
            return this.i.kl;
        },
        set: function (v) {
            this.i.kl = +v;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(IgrNumericCellInfo.prototype, "hasDecimalValue", {
        /**
         * Sets or gets whether there is a decimal numeric value to use for the cell.
        */
        get: function () {
            return this.i.kh;
        },
        set: function (v) {
            this.i.kh = ensureBool(v);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(IgrNumericCellInfo.prototype, "formatOverride", {
        /**
         * The format options to apply to the value
        */
        get: function () {
            return this.i.k5;
        },
        set: function (v) {
            this.i.k5 = v;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(IgrNumericCellInfo.prototype, "negativePrefix", {
        /**
         * Sets or gets the text prepended to a negative numeric value
        */
        get: function () {
            return this.i.lf;
        },
        set: function (v) {
            this.i.lf = v;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(IgrNumericCellInfo.prototype, "positivePrefix", {
        /**
         * Sets or gets the text prepended to a positive numeric value
        */
        get: function () {
            return this.i.lk;
        },
        set: function (v) {
            this.i.lk = v;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(IgrNumericCellInfo.prototype, "negativeSuffix", {
        /**
         * Sets or gets the text appended to a negative numeric value
        */
        get: function () {
            return this.i.lh;
        },
        set: function (v) {
            this.i.lh = v;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(IgrNumericCellInfo.prototype, "positiveSuffix", {
        /**
         * Sets or gets the text appended to a positive numeric value
        */
        get: function () {
            return this.i.lm;
        },
        set: function (v) {
            this.i.lm = v;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(IgrNumericCellInfo.prototype, "maxFractionDigits", {
        /**
         * The maximum number of decimal places to display when formatting
        */
        get: function () {
            return this.i.kr;
        },
        set: function (v) {
            this.i.kr = +v;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(IgrNumericCellInfo.prototype, "minFractionDigits", {
        /**
         * The minimum number of decimal places to display when formatting
        */
        get: function () {
            return this.i.kt;
        },
        set: function (v) {
            this.i.kt = +v;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(IgrNumericCellInfo.prototype, "minIntegerDigits", {
        /**
         * The minimum number of integer digits to display when formatting
        */
        get: function () {
            return this.i.kv;
        },
        set: function (v) {
            this.i.kv = +v;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(IgrNumericCellInfo.prototype, "showGroupingSeparator", {
        /**
         * Sets or gets if the grouping separator is shown
        */
        get: function () {
            return this.i.kj;
        },
        set: function (v) {
            this.i.kj = ensureBool(v);
        },
        enumerable: true,
        configurable: true
    });
    return IgrNumericCellInfo;
}(IgrCellInfo));
export { IgrNumericCellInfo };
//# sourceMappingURL=igr-numeric-cell-info.js.map
